<div class="banner d-lg-flex d-none" *ngIf="!hideNav">
  <h1>{{ bannerText | translate }}</h1>
</div>

<fgb-mixed-loyalty-nav
  *ngIf="!hideNav"
  [class.d-none]="isWalletRoute"
  [class.d-lg-block]="isWalletRoute"
  [selectedIndex]="selectedIndex"
  (tabSelectionChange)="onTabChange($event)"
></fgb-mixed-loyalty-nav>

<router-outlet></router-outlet>
